import { __ } from "@wordpress/i18n";
import { withSelect } from "@wordpress/data";
const { InspectorControls } = wp.blockEditor;

import { ClipboardButton, TabPanel, Panel, PanelBody, PanelRow, Snackbar } from "@wordpress/components";
import { useState } from "@wordpress/element";
import ModelForm from "./Components/Tabs/General/ModelForm";
import Style from "./Components/Tabs/Style/Style";
import Additional from "./Components/Tabs/Style/Additional";
import Options from "./Components/Tabs/General/Options";
import O3DVOptions from "./Components/Tabs/General/O3DVOptions";
import Texture from "./Components/Tabs/General/Texture";
import EnvironmentImage from "./Components/Tabs/General/EnvironmentImage";

import "./settings.scss";

const Settings = ({ attributes, setAttributes, postId, postType, viewerRef }) => {
  const [copied, setCopied] = useState(false);
  const { currentViewer } = attributes;

  return (
    <InspectorControls>
      {postType === "bp3d-model-viewer" && (
        <PanelBody>
          <PanelRow>
            <div className="b3dviewer_front_shortcode justify-center">
              <ClipboardButton
                title={copied ? __("Copied", "model-viewer") : ""}
                variant="primary"
                text={`[3d_viewer id=${postId}]`}
                onCopy={() => setCopied(true)}
                onFinishCopy={() => setCopied(false)}
              >
                {__("Copy Shortcode", "model-viewer")}
              </ClipboardButton>
              {copied && <Snackbar>{__("Copied Succesfully", "model-viewer")}</Snackbar>}
            </div>
          </PanelRow>
        </PanelBody>
      )}
      <TabPanel
        className="b3dviewer-tab-panel"
        activeClass="active"
        tabs={[
          {
            name: "settings",
            title: __("Settings", "model-viewer"),
            className: "settings",
          },
          {
            name: "style",
            title: __("Style", "model-viewer"),
            className: "style",
          },
        ]}
      >
        {(tab) => {
          return (
            <span>
              {tab.name === "settings" && (
                <Panel>
                  <ModelForm attributes={attributes} setAttributes={setAttributes} />

                  {currentViewer === "modelViewer" && <EnvironmentImage attributes={attributes} setAttributes={setAttributes} />}
                  {/* {currentViewer === "modelViewer" && <Texture viewerRef={viewerRef} attributes={attributes} setAttributes={setAttributes} />} */}
                  {currentViewer === "modelViewer" && <Options attributes={attributes} setAttributes={setAttributes} />}
                  {currentViewer === "O3DViewer" && <O3DVOptions attributes={attributes} setAttributes={setAttributes} />}
                </Panel>
              )}
              {tab.name === "style" && (
                <Panel>
                  <Style attributes={attributes} setAttributes={setAttributes} />
                  <Additional attributes={attributes} setAttributes={setAttributes} />
                </Panel>
              )}
            </span>
          );
        }}
      </TabPanel>
    </InspectorControls>
  );
};

export default withSelect((select) => {
  const postType = select("core/editor")?.getCurrentPostType() || "product";
  const postId = select("core/editor")?.getCurrentPostId();

  return {
    postId,
    postType,
  };
})(Settings);
